const semanticClassNames = {
  root: 'lightbox__close-button',
} as const;

export default semanticClassNames;
